export interface ICheckinProcessConfiguration {
  hasFacialRecognition: boolean;
  hasPassportScanner: boolean;
  hasReservation: boolean;
  hasManualFlow: boolean;
  hasGuestFlow: boolean;
  hasTraineeFlow: boolean;
  hasReprintBadgeFlow: boolean;
  hasCovidDeclarationFlow: boolean;
  hasDailyCheckinCheckoutFlow: boolean;
  hasIHaveAQrCodeFlow: boolean;
  hasCoronavirusScreen: boolean;
  hasMaxxessTurnstiles: boolean;
  hasFaceCrop: boolean;
  hasGovernmentId: boolean;
  hasPrintBadge: boolean;
  hasTsa: boolean;
  hasDocumentManagement: boolean;
  hasExportControl: boolean;
  hasPayment: boolean;
  hasPhotoOnBadge: boolean;
  hasEmailMandatory: boolean;
  hasPreCheckin: boolean;
  hasMkDenialValidation: boolean;
  hasDashboardScanner: boolean;
  hasPreCheckinIos: boolean;
  hasPreCheckinAndroid: boolean;
  hasPreCheckinEmailNotification: boolean;
  hasPreCheckinWeb: boolean;
  hasAccessBadge: boolean;
}

export class CheckinProcessConfiguration implements ICheckinProcessConfiguration
{
  hasFacialRecognition: boolean;
  hasPassportScanner: boolean;
  hasReservation: boolean;
  hasManualFlow: boolean;
  hasGuestFlow: boolean;
  hasTraineeFlow: boolean;
  hasReprintBadgeFlow: boolean;
  hasCovidDeclarationFlow: boolean;
  hasDailyCheckinCheckoutFlow: boolean;
  hasIHaveAQrCodeFlow: boolean;
  hasCoronavirusScreen: boolean;
  hasMaxxessTurnstiles: boolean;
  hasFaceCrop: boolean;
  hasGovernmentId: boolean;
  hasPrintBadge: boolean;
  hasTsa: boolean;
  hasDocumentManagement: boolean;
  hasExportControl: boolean;
  hasPayment: boolean;
  hasPhotoOnBadge: boolean;
  hasEmailMandatory: boolean;
  hasPreCheckin: boolean;
  hasMkDenialValidation: boolean;
  hasDashboardScanner: boolean;
  hasPreCheckinIos: boolean;
  hasPreCheckinAndroid: boolean;
  hasPreCheckinEmailNotification: boolean;
  hasPreCheckinWeb: boolean;
  hasAccessBadge: boolean;

  constructor(clone: ICheckinProcessConfiguration = null) {
    this.hasFacialRecognition = false;
    this.hasPassportScanner = false;
    this.hasReservation = false;
    this.hasManualFlow = false;
    this.hasGuestFlow = false;
    this.hasTraineeFlow = false;
    this.hasReprintBadgeFlow = false;
    this.hasCovidDeclarationFlow = false;
    this.hasDailyCheckinCheckoutFlow = false;
    this.hasIHaveAQrCodeFlow = false;
    this.hasCoronavirusScreen = false;
    this.hasMaxxessTurnstiles = false;
    this.hasFaceCrop = false;
    this.hasGovernmentId = false;
    this.hasPrintBadge = false;
    this.hasTsa = false;
    this.hasDocumentManagement = false;
    this.hasExportControl = false;
    this.hasPayment = false;
    this.hasPhotoOnBadge = false;
    this.hasEmailMandatory = false;
    this.hasPreCheckin = false;
    this.hasMkDenialValidation = false;
    this.hasDashboardScanner = false;
    this.hasPreCheckinIos = false;
    this.hasPreCheckinAndroid = false;
    this.hasPreCheckinEmailNotification = false;
    this.hasPreCheckinWeb = false;
    this.hasAccessBadge = false;

    if (clone) {
      this.hasFacialRecognition = clone.hasFacialRecognition;
      this.hasPassportScanner = clone.hasPassportScanner;
      this.hasReservation = clone.hasReservation;
      this.hasManualFlow = clone.hasManualFlow;
      this.hasGuestFlow = clone.hasGuestFlow;
      this.hasTraineeFlow = clone.hasTraineeFlow;
      this.hasReprintBadgeFlow = clone.hasReprintBadgeFlow;
      this.hasCovidDeclarationFlow = clone.hasCovidDeclarationFlow;
      this.hasDailyCheckinCheckoutFlow = clone.hasDailyCheckinCheckoutFlow;
      this.hasIHaveAQrCodeFlow = clone.hasIHaveAQrCodeFlow;
      this.hasCoronavirusScreen = clone.hasCoronavirusScreen;
      this.hasMaxxessTurnstiles = clone.hasMaxxessTurnstiles;
      this.hasFaceCrop = clone.hasFaceCrop;
      this.hasGovernmentId = clone.hasGovernmentId;
      this.hasPrintBadge = clone.hasPrintBadge;
      this.hasTsa = clone.hasTsa;
      this.hasDocumentManagement = clone.hasDocumentManagement;
      this.hasExportControl = clone.hasExportControl;
      this.hasPayment = clone.hasPayment;
      this.hasPhotoOnBadge = clone.hasPhotoOnBadge;
      this.hasEmailMandatory = clone.hasEmailMandatory;
      this.hasPreCheckin = clone.hasPreCheckin;
      this.hasMkDenialValidation = clone.hasMkDenialValidation;
      this.hasDashboardScanner = clone.hasDashboardScanner;
      this.hasPreCheckinIos = clone.hasPreCheckinIos;
      this.hasPreCheckinAndroid = clone.hasPreCheckinAndroid;
      this.hasPreCheckinEmailNotification =
        clone.hasPreCheckinEmailNotification;
      this.hasPreCheckinWeb = clone.hasPreCheckinWeb;
      this.hasAccessBadge = clone.hasAccessBadge;
    }
  }
}
